'use client';
import { useRef, useEffect } from 'react';

var useDidUpdate = function(fn, dependencies) {
    var mounted = useRef(false);
    useEffect(function() {
        return function() {
            mounted.current = false;
        };
    }, []);
    useEffect(function() {
        if (mounted.current) {
            return fn();
        }
        mounted.current = true;
        return undefined;
    }, dependencies);
};

export { useDidUpdate };
